import config from "@~/envConfig";
import { SocialProofMessages } from "@~/contexts/SocialProofMessagesContext/SocialProofMessagesContext";
import { ProductV2 } from "@~/types/prodcatBaseTypes";
import { Product } from "@~/types/types";

const API_URL = config.socialProofApi;

export default async function fetchSocialProofData(
  products: Product[],
  appId: string,
): Promise<SocialProofMessages[]> {
  const extractAvailability = (product: Product) => {
    const prod = product as unknown as ProductV2;
    return (
      prod.variants.length > 0 &&
      prod.variants[0] &&
      prod.variants[0].availability?.availableToOrder
    );
  };

  const productsData = products.map((product) => ({
    productId: product.aliases.pimProductId,
    brand: product.brand?.name,
    availableToOrder: extractAvailability(product) || false,
  }));

  return fetch(API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ products: productsData, appId }),
  }).then((response) => {
    if (response.ok) {
      return response.json();
    }
    throw new Error(
      "Error fetching social proof messaging data " + response.status,
    );
  });
}
